import React from "react";
import Navbar from "@/components/stori/Navbar";
import Hero from "@/components/stori/Hero";
import TrustStrip from "@/components/stori/TrustStrip";
import BrandMarquee from "@/components/stori/BrandMarquee";
import HeroTestimonials from "@/components/stori/HeroTestimonials";
import InventedSelfieCam from "@/components/stori/InventedSelfieCam";
import ExperiencesGrid from "@/components/stori/ExperiencesGrid";
import SocialProof from "@/components/stori/SocialProof";
import HowItWorks from "@/components/stori/HowItWorks";
import CaseStudies from "@/components/stori/CaseStudies";
import SoftwareOnlyCTA from "@/components/stori/SoftwareOnlyCTA";
import FAQ from "@/components/stori/FAQ";
import FinalCTA from "@/components/stori/FinalCTA";
import Footer from "@/components/stori/Footer";
import { LeadModalProvider } from "@/components/stori/LeadModalContext";
import LeadFormModal from "@/components/stori/LeadFormModal";
import Seo from "@/seo/Seo";
import { buildFaqLd } from "@/seo/FAQBlock";

const HOMEPAGE_FAQ = [
  {
    q: "What is Stori?",
    a: "Stori is an AI-powered selfie cam and photo experience platform for live events and permanent venues. It captures branded guest photos, detects influencers in real time, syncs leads to your CRM, and automates marketing follow-up.",
  },
  {
    q: "Who invented the AI selfie cam?",
    a: "Stori invented the AI selfie cam in 2013 and has powered 25 million+ guest interactions across 27 countries and 10,000+ events.",
  },
  {
    q: "Where does Stori work?",
    a: "Stori works for live events (brand launches, festivals, corporate summits, trade shows) and permanent installations (hotels, restaurants, retail flagships, lobbies, wellness, museums).",
  },
  {
    q: "How does the influencer detection work?",
    a: "After a guest opts in with their handle or email, Stori cross-references the lead against Instagram and TikTok in real time and surfaces a VIP alert to the venue team within seconds.",
  },
  {
    q: "What integrations does Stori support?",
    a: "Stori syncs leads natively to HubSpot, Salesforce, and Klaviyo, exports to CSV, and supports an open API for any CRM or marketing platform.",
  },
];

export default function Landing() {
  return (
    <LeadModalProvider>
      <Seo path="/" jsonLd={[buildFaqLd(HOMEPAGE_FAQ)]} />
      <main data-testid="landing-page" className="bg-stori-bg text-white overflow-x-hidden">
        <Navbar />
        <Hero />
        <TrustStrip />
        <BrandMarquee />
        <HeroTestimonials />
        <InventedSelfieCam />
        <ExperiencesGrid />
        <SocialProof />
        <HowItWorks />
        <CaseStudies />
        <SoftwareOnlyCTA />
        <FAQ />
        <FinalCTA />
        <Footer />
        <LeadFormModal />
      </main>
    </LeadModalProvider>
  );
}
